module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "task-list-container"
  }, _vm._l((_vm.tasks), function(task, index) {
    return _c('task-item', {
      key: task.id,
      attrs: {
        "is-selected": task.isSelected
      },
      on: {
        "task-selected": function($event) {
          _vm.onTaskSelected(index)
        },
        "task-delete": function($event) {
          _vm.onTaskDelete(index)
        }
      },
      model: {
        value: (task.text),
        callback: function($$v) {
          task.text = $$v
        },
        expression: "task.text"
      }
    })
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f0e76be","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/TasksList.vue
// module id = 1182
// module chunks = 9 10 34